if (!customElements.get("switch-column")) {
  customElements.define(
    "switch-column",
    class SwitchColumn extends HTMLElement {
      static MOBILE_WIDTH_BREAKPOINT = 600;
      static DEFAULT_MOBILE_COLUMNS = '1';
      static DEFAULT_DESKTOP_COLUMNS = '2';
      // Las dos vistas móviles son de 2 columnas (la 1 con los B17 a fila completa, la
      // 2 sin ellos): el nº de vista no es el de columnas.
      static MOBILE_GRID_COLUMNS = '2';

      constructor() {
        super();
      }

      connectedCallback() {
        this.initialize();
      }

      initialize() {
        this.container = this.querySelector(
          ".collection__mobile-layout-switch",
        );
        this.loader = this.querySelector(".loading-overlay");
        this.checkInput = document.querySelector(
          ".collection__mobile-layout-checkbox",
        );
        this.gridButton = this.container.querySelector(".css-icon--grid");
        this.squareButton = this.container.querySelector(".css-icon--square");
        this.sortCustomSelect = document.querySelector(
          '[data-reference-id="SortBy"]',
        );

        this.boundChangeNumberOfColumns = this.changeNumberOfColumns.bind(this);
        this.boundHandleResize = this.handleResize.bind(this);
        this.boundHandleLoad = this.handleLoad.bind(this);

        this.addEventListeners();

        if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          this.setNumberOfColumns();
        }
      }

      addEventListeners() {
        window.addEventListener("load", this.boundHandleLoad);
        window.addEventListener("resize", this.boundHandleResize);
        if (this.sortCustomSelect) {
          this.sortCustomSelect.addEventListener(
            "wtSelectChange",
            this.boundHandleLoad,
          );
        }
        if (this.checkInput) {
          this.checkInput.addEventListener(
            "change",
            this.boundChangeNumberOfColumns,
          );
        }
      }

      removeEventListeners() {
        window.removeEventListener("load", this.boundHandleLoad);
        window.removeEventListener("resize", this.boundHandleResize);
        if (this.checkInput) {
          this.checkInput.removeEventListener(
            "change",
            this.boundChangeNumberOfColumns,
          );
        }
        if (this.sortCustomSelect) {
          this.sortCustomSelect.removeEventListener(
            "wtSelectChange",
            this.boundHandleLoad,
          );
        }
      }

      handleLoad() {
        this.loader.classList.add("loading-overlay--hidden");
        this.container.classList.remove(
          "collection__mobile-layout-switch--hidden",
        );
        if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          this.setNumberOfColumns();
        }
      }

      handleResize() {
        const grid = this.getGrid();
        if (!grid) return;
        if (
          window.innerWidth >= SwitchColumn.MOBILE_WIDTH_BREAKPOINT &&
          grid.style.getPropertyValue("--cols")
        ) {
          grid.style.removeProperty("--cols");
          grid.classList.remove('vista-1', 'vista-2', 'vista-4', 'is-mobile');
          grid.classList.add('vista-' + SwitchColumn.DEFAULT_DESKTOP_COLUMNS, 'is-desktop');
        } else if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          if (!this.loader.classList.contains("loading-overlay--hidden")) {
            this.loader.classList.add("loading-overlay--hidden");
          }
          if (
            this.container.classList.contains(
              "collection__mobile-layout-switch--hidden",
            )
          ) {
            this.container.classList.remove(
              "collection__mobile-layout-switch--hidden",
            );
          }
          this.setNumberOfColumns();
        }
      }

      getNumberOfColumns() {
        return this.dataset.col;
      }

      getGrid() {
        return document.querySelector('.collection__grid');
      }

      applyViewClasses(colsNumber) {
        const grid = this.getGrid();
        if (!grid) return;
        grid.classList.remove('vista-1', 'vista-2', 'vista-4');
        grid.classList.add('vista-' + colsNumber);
        grid.classList.add('is-mobile');
        grid.classList.remove('is-desktop');
      }

      setNumberOfColumns() {
        const grid = this.getGrid();
        if (!grid) return;
        // La vista móvil también la cambia #gridToggleBtn (script inline de
        // main-collection-product-grid), que solo actualiza data-mobile-cols del grid.
        // Leer de ahí el estado real: si no, el load (tarde en la primera visita, sin
        // caché) o los resize del scroll en móvil (barra del navegador) devolvían la
        // parrilla a vista 1 tras haber pulsado "Vista 2".
        const vistaNumber = grid.getAttribute('data-mobile-cols') || this.dataset.col || SwitchColumn.DEFAULT_MOBILE_COLUMNS;

        if (this.checkInput) {
          this.checkInput.checked = vistaNumber === '2';
        }

        // Ya está en esa vista: no tocar las clases (cada mutación de class fuerza un
        // relayout completo de la parrilla en collection-grid-layout.js).
        if (
          grid.style.getPropertyValue("--cols") === SwitchColumn.MOBILE_GRID_COLUMNS &&
          grid.classList.contains('vista-' + vistaNumber) &&
          grid.classList.contains('is-mobile')
        ) {
          this.dataset.col = vistaNumber;
          this.changeColorOfButtons();
          return;
        }

        grid.style.setProperty("--cols", SwitchColumn.MOBILE_GRID_COLUMNS);
        grid.setAttribute('data-mobile-cols', vistaNumber);
        this.applyViewClasses(vistaNumber);
        this.dataset.col = vistaNumber;
        this.changeColorOfButtons();
      }

      changeNumberOfColumns() {
        const newValue = this.checkInput && this.checkInput.checked ? '2' : '1';
        const grid = this.getGrid();
        if (!grid) return;

        grid.style.setProperty("--cols", SwitchColumn.MOBILE_GRID_COLUMNS);
        grid.setAttribute('data-mobile-cols', newValue);
        this.applyViewClasses(newValue);
        this.dataset.col = newValue;
        this.changeColorOfButtons();

        if (window.analyticsUtils && window.analyticsUtils.pushGridViewEventToDataLayer) {
          window.analyticsUtils.pushGridViewEventToDataLayer(newValue);
        }
      }

      changeColorOfButtons() {
        const colsNumber = this.getNumberOfColumns();
        const primaryColor = "var(--color-text)";
        const secondaryColor = "var(--color-border)";

        this.squareButton.style.setProperty(
          "--icon-color",
          colsNumber === "1" ? primaryColor : secondaryColor,
        );
        this.gridButton.style.setProperty(
          "--icon-color",
          colsNumber === "2" ? primaryColor : secondaryColor,
        );
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    },
  );
}
